import http from '@/http/aisea/axios'
const resource = "/port_master/enterprises/ports";

export default {
  export(portId, date) {
    return http.get(`${resource}/${portId}/daily_reports/${date}`, { responseType : 'blob' });
  },
};